import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { denormalize } from 'normalizr';
import moment from 'moment';
import 'react-table/react-table.css';
import { getTranslate } from 'react-localize-redux';
import { red500, red300, lightGreen500 } from 'material-ui/styles/colors';
import Clear from 'material-ui/svg-icons/content/clear';
import Done from 'material-ui/svg-icons/action/done';
import { translate } from 'react-i18next';
import ExitToApp from 'material-ui/svg-icons/action/exit-to-app';
import FlatButton from 'material-ui/FlatButton';

import { dateFromISO } from '../utils/helpers';
import { getCollectionRequestData } from '../utils/react-table-helpers';
import CommonTable from '../components/CommonTable';
import TextFilterField from '../components/filters/TextFilterField';
import DateRangeFilterField from '../components/filters/DateRangeFilterField';
import YesNoFilterField from '../components/filters/YesNoFilterField';
import EnumSelectFilterField from '../components/filters/EnumSelectFilterField';
import { PACKETBOX_STATE_ENUMS } from '../config';
import * as packetboxActions from '../redux/modules/packetboxes';
import * as alertTypeActions from '../redux/modules/alertTypes';
import { API_URL } from '../config';
import { CALL_API } from '../redux//middleware/api';
import httpClient from '../utils/httpClient';
import i18n from '../translations/i18n';

const paketboxSchema = packetboxActions.paketboxes;

/*
PropTypes / DefaultProps
 */
const defaultProps = {
  loading: false,
  packetboxes: {},
};

const propTypes = {
  loading: PropTypes.bool,
  packetboxes: PropTypes.object,
  fetchPacketboxes: PropTypes.func,
  fetchAlertTypes: PropTypes.func,
  t: PropTypes.func,
  alertTypes: PropTypes.any,
};

class PacketboxList extends React.Component {
  constructor(props) {
    super(props);

    this.batteryThreshold = null;
    this.state = {
      pageSize: 10,
      lastRequest: null,
    };
  }
  /*
    Lifecycle methods
   */
  componentWillMount() {
    this.props.fetchPacketboxes();
    this.props.fetchAlertTypes();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.alertTypes) {
      Object.keys(nextProps.alertTypes).forEach((key) => {
        const alertType = nextProps.alertTypes[key];

        if (alertType.type === 'BATTERY') {
          this.batteryThreshold = parseFloat(alertType.min_value);
        }
      });
    }
  }

  /*
    Custom methods
   */
  initColumns() {
    this.columns = [
      {
        header: this.props.t('name'),
        show: true,
        accessor: 'name',
        // render: row => row.value,
        // filterMethod: (filter, row) => row.name.toLowerCase().indexOf(filter.value.toLowerCase()) >= 0,
        filterRender: ({ filter, onFilterChange }) => (
          <TextFilterField name="name" filter={filter} onFilterChange={onFilterChange} />
        ),
      },

      {
        header: this.props.t('owner'),
        accessor: 'owner___first_name',
        filterMethod: (filter, row) => {
          const firstName =
            row &&
            row.__original &&
            row.__original &&
            row.__original.owner___first_name &&
            row.__original.owner___first_name.toLowerCase();
          const lastName =
            row &&
            row.__original &&
            row.__original &&
            row.__original.owner___last_name &&
            row.__original.owner___last_name.toLowerCase();
          const name = `${firstName} ${lastName}`;

          return name.indexOf(filter.value.toLowerCase()) >= 0;
        },

        filterRender: ({ filter, onFilterChange }) => (
          <TextFilterField name="name" filter={filter} onFilterChange={onFilterChange} />
        ),
        render: (cellInfo) => {
          if (cellInfo.rowValues.owner___first_name) {
            return `${cellInfo.row.owner___first_name} ${cellInfo.row.owner___last_name}`;
          }
          return cellInfo.row.owner___username;
        },
      },

      /*
          -- Address --
       */
      {
        header: this.props.t('street'),
        accessor: 'street',
        render: row => row.value,
        filterMethod: (filter, row) => {
          if (!row.street) return false;

          return row.street.toLowerCase().indexOf(filter.value.toLowerCase()) >= 0;
        },
        filterRender: ({ filter, onFilterChange }) => (
          <TextFilterField name="street" filter={filter} onFilterChange={onFilterChange} />
        ),
      },
      {
        header: this.props.t('number'),
        accessor: 'street_number',
        filterMethod: (filter, row) => {
          if (!row.street_number) return false;
          return row.street_number.toLowerCase().indexOf(filter.value.toLowerCase()) >= 0;
        },
        filterRender: ({ filter, onFilterChange }) => (
          <TextFilterField name="street_number" filter={filter} onFilterChange={onFilterChange} />
        ),
      },
      {
        header: this.props.t('postal_code'),
        accessor: 'postal_code',
        render: row => row.value,
        filterMethod: (filter, row) => {
          if (!row.postal_code) return false;
          return row.postal_code.toLowerCase().indexOf(filter.value.toLowerCase()) >= 0;
        },
        filterRender: ({ filter, onFilterChange }) => (
          <TextFilterField name="postal_code" filter={filter} onFilterChange={onFilterChange} />
        ),
      },
      {
        header: this.props.t('place'),
        accessor: 'place',
        render: row => row.value,
        filterMethod: (filter, row) => {
          if (!row.place) return false;

          return row.place.toLowerCase().indexOf(filter.value.toLowerCase()) >= 0;
        },
        filterRender: ({ filter, onFilterChange }) => (
          <TextFilterField name="place" filter={filter} onFilterChange={onFilterChange} />
        ),
      },

      /*
          -- Address END --
       */
      {
        header: this.props.t('state'),
        accessor: 'state',
        className: 'centerAlign',
        render: (row) => {
          if (row.value === 'LOCKED_AFTER_BUTTON_OPEN') {
            return this.props.t('PKB_LOCKED_AFTER_BUTTON_OPEN');
          }
          return this.props.t(row.value);
        },
        filterRender: ({ filter, onFilterChange }) => (
          <EnumSelectFilterField
            values={PACKETBOX_STATE_ENUMS}
            name="state"
            filter={filter}
            onFilterChange={onFilterChange}
          />
        ),
        apiRequest: {
          filterTransform: value => value === 'PKB_LOCKED_AFTER_BUTTON_OPEN' ? value = 'LOCKED_AFTER_BUTTON_OPEN' : value,
          operator: 'eq',
        },
      },
      {
        header: this.props.t('pin'),
        accessor: 'pin',
        className: 'centerAlign',
        width: 60,
        render: row => (row.value === 0 ? '- - - -' : row.value.toString().padStart(4, '0')),
        filterMethod: (filter, row) => parseInt(filter.value, 10) === parseInt(row.pin, 10),
        filterRender: ({ filter, onFilterChange }) => (
          <TextFilterField name="pin" filter={filter} onFilterChange={onFilterChange} />
        ),
        apiRequest: {
          filterTransform: value => parseInt(value, 10),
          operator: 'eq',
        },
      },

      {
        header: this.props.t('battery'),
        accessor: 'battery',
        className: 'centerAlign',
        width: 150,
        render: (row) => {
          if (row.value == null) {
            return '-';
          }

          const batteryValue = parseFloat(Math.round(row.value * 100) / 100).toFixed(2);

          if (this.batteryThreshold && batteryValue < this.batteryThreshold) {
            return <blink style={{ color: red500 }}>{batteryValue}V</blink>;
          }

          return `${batteryValue}V`;
        },
        filterMethod: (filter, row) => parseFloat(filter.value, 10) > parseFloat(row.battery, 10),
        filterRender: ({ filter, onFilterChange }) => (
          <span>
            <span style={{ fontSize: 10 }}>{this.props.t('less_than')}: </span>
            <TextFilterField name="battery" filter={filter} onFilterChange={onFilterChange} />
          </span>
        ),
        apiRequest: {
          filterTransform: value => parseFloat(value),
          operator: 'lt',
        },
      },
      {
        header: this.props.t('temperature'),
        show: false,
        accessor: 'temperature',
        className: 'centerAlign',
        width: 100,
        render: row =>
          row.value || row.value === 0
            ? `${parseFloat(Math.round(row.value * 100) / 100).toFixed(1)} °C`
            : '-',
        filterMethod: (filter, row) => parseInt(filter.value, 10) === parseInt(row.temperature, 10),
        filterRender: ({ filter, onFilterChange }) => (
          <TextFilterField name="temperature" filter={filter} onFilterChange={onFilterChange} />
        ),
      },
      {
        header: this.props.t('humidity'),
        show: false,
        accessor: 'humidity',
        className: 'centerAlign',
        width: 100,
        render: row => (row.value || row.value === 0 ? `${row.value}%` : '-'),
        filterMethod: (filter, row) => parseInt(filter.value, 10) === parseInt(row.humidity, 10),
        filterRender: ({ filter, onFilterChange }) => (
          <TextFilterField name="humidity" filter={filter} onFilterChange={onFilterChange} />
        ),
      },
      {
        header: this.props.t('lora_signal_strength'),
        accessor: 'lora___lora_snr',
        render: row => row.value,
        className: 'centerAlign',
        width: 60,
        filterMethod: (filter, row) =>
          parseInt(filter.value, 10) === parseInt(row.lora___lora_snr, 10),
        filterRender: ({ filter, onFilterChange }) => (
          <TextFilterField name="lora___lora_snr" filter={filter} onFilterChange={onFilterChange} />
        ),
      },
      {
        header: this.props.t('lora_sf'),
        show: false,
        accessor: 'lora___lora_sf',
        className: 'centerAlign',
        render: row => row.value,
        width: 60,
        filterMethod: (filter, row) =>
          parseInt(filter.value, 10) === parseInt(row.lora___lora_sf, 10),
        filterRender: ({ filter, onFilterChange }) => (
          <TextFilterField name="lora___lora_sf" filter={filter} onFilterChange={onFilterChange} />
        ),
      },
      {
        header: this.props.t('lora_snr'),
        accessor: 'lora___lora_snr',
        render: row => row.value,
        show: false,
        className: 'centerAlign',
        width: 60,
        filterMethod: (filter, row) =>
          parseInt(filter.value, 10) === parseInt(row.lora___lora_snr, 10),
        filterRender: ({ filter, onFilterChange }) => (
          <TextFilterField name="lora___lora_snr" filter={filter} onFilterChange={onFilterChange} />
        ),
      },
      {
        header: this.props.t('time_created'),
        show: false,
        accessor: 'time_created',
        className: 'centerAlign',
        render: row => dateFromISO(row.value),
        filterMethod: (filter, row) => {
          if (!filter.value) return true;
          const startDate = filter.value.startDate.startOf('day');
          const endDate = filter.value.endDate.endOf('day');
          const rowDate = moment(row.time_created);

          return rowDate.isAfter(startDate) && rowDate.isBefore(endDate);
        },
        filterRender: ({ filter, onFilterChange }) => (
          <DateRangeFilterField
            name="time_created"
            filter={filter}
            onFilterChange={onFilterChange}
          />
        ),
      },
      {
        header: this.props.t('last_measurement'),
        show: true,
        accessor: 'last_measurement',
        className: 'centerAlign',
        render: row => { 
          if (row.row.is_active && row.row.state !== "UNCONFIGURED" && moment().isAfter(moment(row.row.last_measurement).add(row.versionMajor <= 3 && row.versionMinor < 4 ? 12 : 24, 'h'))) {
            return <blink style={{ color: red500 }}>{dateFromISO(row.value)}</blink>;
          }
          return dateFromISO(row.value);
        },
        filterRender: ({ filter, onFilterChange }) => (
          <DateRangeFilterField
            name="last_measurement"
            filter={filter}
            onFilterChange={onFilterChange}
          />
        ),

        apiRequest: {
          betweenDates: true,
        },
        filterMethod: (filter, row) => {
          if (!filter.value) return true;
          const startDate = filter.value.startDate.startOf('day');
          const endDate = filter.value.endDate.endOf('day');
          const rowDate = moment(row.last_measurement);

          return rowDate.isAfter(startDate) && rowDate.isBefore(endDate);
        },
      },
      {
        header: this.props.t('code'),
        accessor: 'code',
        render: row => row.value,
        filterMethod: (filter, row) =>
          row.code.toLowerCase().startsWith(filter.value.toLowerCase()),
        filterRender: ({ filter, onFilterChange }) => (
          <TextFilterField name="code" filter={filter} onFilterChange={onFilterChange} />
        ),
      },
      {
        header: this.props.t('fw_version'),
        accessor: 'version',
        className: 'centerAlign',
        filterMethod: (filter, row) =>
          row.version !== undefined ? row.version.toLowerCase().startsWith(filter.value.toLowerCase()) : null,
        filterRender: ({ filter, onFilterChange }) => (
          <TextFilterField name="version" filter={filter} onFilterChange={onFilterChange} />
        ),
      },
      {
        header: this.props.t('activated'),
        accessor: 'is_active',
        className: 'centerAlign',
        render: row => (row.value ? <Done color={lightGreen500} /> : <Clear color={red300} />),
        filterRender: ({ filter, onFilterChange }) => (
          <YesNoFilterField name="is_active" filter={filter} onFilterChange={onFilterChange} />
        ),
        apiRequest: {
          filterTransform: value => value,
          operator: 'eq',
        },
        filterMethod: (filter, row) => row.is_active === filter.value,
      },
      {
        header: this.props.t('id'),
        show: true,
        accessor: 'id',
        className: 'centerAlign',
        width: 60,
        render: row => row.value,
        filterMethod: (filter, row) => parseInt(filter.value, 10) === parseInt(row.id, 10),
        filterRender: ({ filter, onFilterChange }) => (
          <TextFilterField name="id" filter={filter} onFilterChange={onFilterChange} />
        ),
        apiRequest: {
          filterTransform: value => parseInt(value, 10),
          operator: 'eq',
        },
      },
    ];
  };

  getExportLink = () => {
    let exportQuery = {
      skip: 0,
      take: 200000,
    };

    if (this.state.lastRequest && this.state.lastRequest.filter) {
      exportQuery.filter = this.state.lastRequest.filter;
    }

    if (this.state.lastRequest && this.state.lastRequest.sort) {
      exportQuery.sort = this.state.lastRequest.sort;
    }

    exportQuery = JSON.stringify(exportQuery);
    const exportLink = `${API_URL}/exportcsv/paketbox?query=${exportQuery}`;
    return exportLink;
  };

  fetchData = (state) => {
    const request = getCollectionRequestData(state);
    // this.props.fetchPacketboxes();
    // this.props.fetchAlertTypes();

    clearTimeout(this.state.timeout);
    const timeout = setTimeout(() => {
      this.props.fetchPacketboxes(request);
    }, 300);

    this.setState({ timeout });

    this.setState({ pageSize: state.pageSize, lastRequest: request });
  };

  itemEdit = (id) => {
    browserHistory.push(`/packetboxes/modify/${id}`);
  };

  render() {
    this.initColumns();

    let data = [];

    if (this.props.packetboxes) {
      if (Object.values(this.props.packetboxes).length > 0) {
        const denormalized = denormalize(
          this.props.packetboxes,
          { data: [paketboxSchema] },
          { paketboxes: this.props.packetboxes }
        );

        data = denormalized.data;
      }
    }

    const exportButton = (
      <FlatButton
        href={this.getExportLink()}
        label={this.props.t('export')}
        target="_blank"
        icon={<ExitToApp />}
      />
    );

    if (this.props.packetboxes) {
      data = Object.values(this.props.packetboxes).map(packetbox => {
        if (packetbox.versionMajor !== null &&
          packetbox.versionMinor !== null &&
          packetbox.versionPatch !== null &&
          packetbox.versionBuild !== null) {
            const version = packetbox.versionMajor + '.' + packetbox.versionMinor + '.' + packetbox.versionPatch + '.' + packetbox.versionBuild
            packetbox.version = version;
          }
        return packetbox;
      });
    }

    return (
      <CommonTable
        title={this.props.t('paketbox_list')}
        rightComponent={<div>{exportButton}</div>}
        data={data}
        // manual
        onItemEdit={this.itemEdit}
        loading={this.props.loading}
        columns={this.columns}
        onChange={this.fetchData}
      />
    );
  }
}

PacketboxList.defaultProps = defaultProps;
PacketboxList.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    loading: state.packetboxes.fetching,
    packetboxes: state.packetboxes.entities,
    alertTypes: state.alertTypes.entities,
    translate: getTranslate(state.locale),
  };
}

const actions = Object.assign({}, alertTypeActions, packetboxActions);

const extended = translate(['translations'], { i18n })(PacketboxList);
export default connect(mapStateToProps, actions)(extended);



// WEBPACK FOOTER //
// ./src/containers/PacketboxList.js